import * as yup from "yup";

/**
 * Server-side filters for GET publishers/v1 (cross-brand Publishers listing).
 */
export const publisherFiltersSchema = yup.object({
    search    : yup.string().trim().default(""),
    account_id: yup.string().trim().default(""),
    kyc_status: yup.string().trim().default("")
});

export const defaultPublisherFilters = publisherFiltersSchema.getDefault();

export const toPublisherFilterParams = async (filters) => {
    const validated = await publisherFiltersSchema.validate(filters, { stripUnknown: true });

    const params = {};
    if (validated.search) params.search = validated.search;
    if (validated.account_id) params.account_id = validated.account_id;
    if (validated.kyc_status) params.kyc_status = validated.kyc_status;

    return params;
};
